import Icons from "../svg/Icons.ts";

/**
 * return files picked by User
 */
export async function pickFileFromDevice(accept :string,multiple = false) :Promise<File[]>{
  return new Promise((resolve,reject)=>{
    var input = document.createElement('input');
    input.type = 'file';
    if(multiple===true){
      input.multiple = true;
    }
    input.accept = accept;
    input.addEventListener('change', e => resolve(Array.from((e.target as HTMLInputElement).files)), {once: true});
    input.addEventListener('cancel', e => resolve([]), {once: true});
    input.click();
  })

}

//FIXME put this elsewhere
export function downloadUrl(url :string,fileName :string){
  var a = document.createElement('a')
  a.textContent = fileName;
  a.download = fileName
  a.href = url;
  a.click()
  return a;
}


type DropConsumer = ()=>Promise<{
  nodes:Iterable<HTMLElement>,
  ondrop:(
    this: HTMLElement,
    ev: DragEvent
  ) => any}>

const
  droppableFactories :DropConsumer[] = [];

export function registerFileDropConsumer(factory :DropConsumer){
  droppableFactories.push(factory)
}

//dragover fires at least every ~350ms while over the page: without it the file left the window or the drag was cancelled
const FILE_DRAG_IDLE_MS = 1000;

var
  fileDrag :{cleanups:(()=>void)[], idleTimeout:number} = null;

function endFileDrag(){
  if(!fileDrag) return;
  clearTimeout(fileDrag.idleTimeout);
  fileDrag.cleanups.forEach(cleanup=>cleanup());
  fileDrag = null;
  document.body.classList.remove('dragging');
}

function checkDragFile(event :DragEvent){
  if(!Array.from(event.dataTransfer.types).includes('Files')) return;
  if(fileDrag){
    clearTimeout(fileDrag.idleTimeout);
    fileDrag.idleTimeout = setTimeout(endFileDrag,FILE_DRAG_IDLE_MS);
    return;
  }

  event.preventDefault();
  document.body.classList.add('dragging');
  const current = fileDrag = {cleanups:[], idleTimeout:setTimeout(endFileDrag,FILE_DRAG_IDLE_MS)};
  droppableFactories.forEach(async (factory)=>{
    var {nodes,ondrop} = await factory();
    //drag already over before the factory resolved
    if(fileDrag!==current) return;
    Array.from(nodes).forEach(node=>{
      function over(event :DragEvent){
        event.preventDefault();
      }
      function drop(this:HTMLElement, event :DragEvent){
        event.preventDefault();
        ondrop.call(this,event)
      }
      node.classList.add('droppable');
      node.addEventListener('dragover',over)
      node.addEventListener('drop',drop)
      current.cleanups.push(()=>{
        node.classList.remove('droppable');
        node.removeEventListener('dragover',over)
        node.removeEventListener('drop',drop)
      })
    })
  })
}
document.body.addEventListener("dragover",checkDragFile)
document.body.addEventListener("drop",function(event){
  event.preventDefault()
  //node drop handlers ran first (bubbling): the file drag is over, wherever it was dropped
  endFileDrag()
})

registerFileDropConsumer(async function(){
  var formsWithFile = Array.from(document.body.querySelectorAll('form')).filter(form=>form.querySelector('input[type="file"]'))
  return {
    nodes:formsWithFile,
    ondrop(this: HTMLElement,event :DragEvent){
      var inputFile = this.querySelector('input[type="file"]') as HTMLInputElement

      if(!acceptFiles(inputFile,event.dataTransfer.files)) return;

      inputFile.files = event.dataTransfer.files;
      inputFile.dispatchEvent(new Event("change"));
    }
  }
})
export function acceptFiles(inputFile :HTMLInputElement, files : FileList ) :boolean{
  const acceptPattern = inputFile.accept.split(',').map(type => type.trim());
  for(var file of Array.from(files)){
    const isAccepted = acceptPattern.some(type => {
      if (type.endsWith('/*')) {
        const baseType = type.slice(0, -1);
        return file.type.startsWith(baseType);
      } else {
        return file.type === type;
      }
    });
    if(!isAccepted) return false;
  }
  return true;
}

class DragError extends Error{};
/**
 * will apply the function to an element when starting to drag it
 * giving a dropPromiseBuilder that must be call with the potential drop target
 */
export function registerDragStart(selector : string,func : (this:HTMLElement,event:DragEvent,dropBuilder:typeof dropPromiseBuilder)=>void){
  document.body.addEventListener('dragstart',async function(event){
    var dragged = event.target as HTMLElement;
    if(dragged.matches && dragged.matches(selector)){
      //Safari never fires drop for a drag carrying no data: must be set synchronously in dragstart
      event.dataTransfer.setData('text/plain', '');
      event.dataTransfer.effectAllowed = 'move';
      try{
        await func.call(dragged,event, dropPromiseBuilder)
      }catch(e){
        if(e instanceof DragError){
          console.log(e.message)
        }else{
          throw e;
        }
      }
    }
  })

}
/**
 * Create a promise of drop of dragging in all dropTargets
 * It create/clean all event listener
 * @param dragging
 * @param dropTargets
 * @returns
 */
export async function dropPromiseBuilder(dragging :HTMLElement,dropTargets :HTMLElement[], excludeDropParent=true):Promise<DragEvent>{
  document.body.classList.add("dragging")

  //clean droptarget keeping only those who do not contains dragging
  if(excludeDropParent){
    dropTargets = dropTargets.filter(dropTarget=>!dropTarget.contains(dragging));
  }

  function prevent(this:HTMLElement, event:DragEvent){
    event.preventDefault();
  }
  //important must have css like .droppable>* : pointer-events: none;
  function enter(this:HTMLElement, event :DragEvent){
    this.classList.add('droppable-active')
  }
  function leave(this:HTMLElement, event :DragEvent){
    this.classList.remove('droppable-active')
  }



  var
    timeout :number,
    onDrop :(event :DragEvent)=>void,
    onDragEnd :()=>void;
  return new Promise<DragEvent>((resolve,reject)=>{
    onDrop = resolve;
    onDragEnd = ()=>reject(new DragError("Drag aborted"));
    document.body.addEventListener("dragend",onDragEnd)
    dropTargets.forEach(dropTarget=>{
      dropTarget.addEventListener("drop",onDrop)
      dropTarget.addEventListener("dragover",prevent)
      dropTarget.addEventListener("dragenter",enter)
      dropTarget.addEventListener("dragleave",leave)
      dropTarget.classList.add("droppable")
    })
    timeout = setTimeout(()=>reject(new DragError("Drag timeout done")),10000)

  }).finally(()=>{
    clearTimeout(timeout)
    document.body.removeEventListener("dragend",onDragEnd)
    dropTargets.forEach(dropTarget=>{
      dropTarget.removeEventListener("drop",onDrop)
      dropTarget.removeEventListener("dragover",prevent)
      dropTarget.removeEventListener("dragenter",enter)
      dropTarget.removeEventListener("dragleave",leave)
      dropTarget.classList.remove("droppable")
      dropTarget.classList.remove("droppable-active")
    })
    document.body.classList.remove("dragging")

  })
}

export function getIconFromMimeType(mimeType : string){
  if(mimeType.indexOf('image')===0){
    return Icons.filer.ic_file_type_image;
  }else if(mimeType.indexOf('video')===0){
    return Icons.filer.ic_file_type_video;
  }else if(mimeType.indexOf('audio')===0){
    return Icons.filer.ic_file_type_sound;
  }else if(mimeType.indexOf('application/pdf')===0){
    return Icons.filer.ic_file_type_pdf;
  }else if(mimeType.indexOf('spreadsheet')>-1||mimeType.indexOf('ms-excel')>-1 ){
    return Icons.filer.ic_file_type_xls;
  }else if(mimeType.indexOf('presentation')>-1||mimeType.indexOf('ms-powerpoint')>-1 ){
    return Icons.filer.ic_file_type_ppt;
  }else if(mimeType.indexOf('document')>-1||mimeType.indexOf('msword')>-1 ){
    return Icons.filer.ic_file_type_doc;
  }else if(mimeType.indexOf('compressed')>-1||mimeType.indexOf('zip')>-1 ){
    return Icons.filer.ic_file_type_zip;
  }else{
    return Icons.filer.ic_file_type_other;
  }
}
export function getSmallIconFromMimeType(mimeType: string){
  if(mimeType.indexOf('image')===0){
    return Icons.filer.ic_file_type_image_small;
  }else if(mimeType.indexOf('video')===0){
    return Icons.filer.ic_file_type_video_small;
  }else if(mimeType.indexOf('audio')===0){
    return Icons.filer.ic_file_type_sound_small;
  }else if(mimeType.indexOf('application/pdf')===0){
    return Icons.filer.ic_file_type_pdf_small;
  }else if(mimeType.indexOf('spreadsheet')>-1||mimeType.indexOf('ms-excel')>-1 ){
    return Icons.filer.ic_file_type_xls_small;
  }else if(mimeType.indexOf('presentation')>-1||mimeType.indexOf('ms-powerpoint')>-1 ){
    return Icons.filer.ic_file_type_ppt_small;
  }else if(mimeType.indexOf('document')>-1||mimeType.indexOf('msword')>-1 ){
    return Icons.filer.ic_file_type_doc_small;
  }else if(mimeType.indexOf('compressed')>-1||mimeType.indexOf('zip')>-1 ){
    return Icons.filer.ic_file_type_zip_small;
  }else{
    return Icons.filer.ic_file_type_other_small;
  }
}

export function iconsimple(file :{mimeType?:string,type:string},css :string){
  var type = file.mimeType?file.mimeType:file.type;
  return `<icon style="${css}">${getSmallIconFromMimeType(type)}</icon>`
}